import {DefaultInteraction} from "./interaction";


export class HideObjectMulti extends DefaultInteraction {

	constructor(props) {
		super(props);
	}


	key() {
		return "hide_object_multi"
	}

	interact(interactionData, metadata, onSuccess, onError) {
		console.log(`Interaction::${this.key()} - Run`, interactionData, metadata)

		for (let target in interactionData.objects) {
			const refObj = this.scene.get(target)
			refObj.visible = false;
		}
		return true
	}

	//TODO Handle proximity triggers
}